module.exports = __webpack_public_path__ + "img/Emmay-Logistics.ef169774.jpg";